export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[]

export type Database = {
  graphql_public: {
    Tables: {
      [_ in never]: never
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      graphql: {
        Args: {
          extensions?: Json
          operationName?: string
          query?: string
          variables?: Json
        }
        Returns: Json
      }
    }
    Enums: {
      [_ in never]: never
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
  public: {
    Tables: {
      grading_prompts: {
        Row: {
          category_code: Database["public"]["Enums"]["category_code"]
          created_at: string
          description: string | null
          id: string
          is_active: boolean
          prompt_template: string
          updated_at: string
        }
        Insert: {
          category_code: Database["public"]["Enums"]["category_code"]
          created_at?: string
          description?: string | null
          id?: string
          is_active?: boolean
          prompt_template: string
          updated_at?: string
        }
        Update: {
          category_code?: Database["public"]["Enums"]["category_code"]
          created_at?: string
          description?: string | null
          id?: string
          is_active?: boolean
          prompt_template?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "grading_prompts_category_code_fkey"
            columns: ["category_code"]
            isOneToOne: true
            referencedRelation: "question_categories"
            referencedColumns: ["category_code"]
          },
        ]
      }
      past_paper_attempt_answers: {
        Row: {
          ai_feedback: string | null
          ai_improvements: string[] | null
          ai_score: number | null
          ai_strengths: string[] | null
          answer_text: string
          attempt_id: string
          created_at: string
          graded_at: string | null
          id: string
          question_id: string
          updated_at: string
        }
        Insert: {
          ai_feedback?: string | null
          ai_improvements?: string[] | null
          ai_score?: number | null
          ai_strengths?: string[] | null
          answer_text?: string
          attempt_id: string
          created_at?: string
          graded_at?: string | null
          id?: string
          question_id: string
          updated_at?: string
        }
        Update: {
          ai_feedback?: string | null
          ai_improvements?: string[] | null
          ai_score?: number | null
          ai_strengths?: string[] | null
          answer_text?: string
          attempt_id?: string
          created_at?: string
          graded_at?: string | null
          id?: string
          question_id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "past_paper_attempt_answers_attempt_id_fkey"
            columns: ["attempt_id"]
            isOneToOne: false
            referencedRelation: "past_paper_attempts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "past_paper_attempt_answers_question_id_fkey"
            columns: ["question_id"]
            isOneToOne: false
            referencedRelation: "questions"
            referencedColumns: ["id"]
          },
        ]
      }
      past_paper_attempts: {
        Row: {
          auth_id: string
          created_at: string
          final_grade: number | null
          id: string
          past_paper_id: string
          started_at: string
          status: Database["public"]["Enums"]["attempt_status"]
          submitted_at: string | null
          updated_at: string
        }
        Insert: {
          auth_id: string
          created_at?: string
          final_grade?: number | null
          id?: string
          past_paper_id: string
          started_at?: string
          status?: Database["public"]["Enums"]["attempt_status"]
          submitted_at?: string | null
          updated_at?: string
        }
        Update: {
          auth_id?: string
          created_at?: string
          final_grade?: number | null
          id?: string
          past_paper_id?: string
          started_at?: string
          status?: Database["public"]["Enums"]["attempt_status"]
          submitted_at?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "past_paper_attempts_past_paper_id_fkey"
            columns: ["past_paper_id"]
            isOneToOne: false
            referencedRelation: "past_papers"
            referencedColumns: ["id"]
          },
        ]
      }
      past_papers: {
        Row: {
          created_at: string
          date: string | null
          exam_board: string | null
          id: string
          mark_scheme_processed_at: string | null
          paper_code: Database["public"]["Enums"]["paper_code"] | null
          paper_number: string | null
          pdf_url: string | null
          reading_insert_content: string | null
          reading_insert_page_numbers: number[] | null
          reading_insert_page_numbers_2: number[] | null
          status: Database["public"]["Enums"]["content_status"]
          subject: Database["public"]["Enums"]["subject"] | null
          time_allowed: number | null
          title: string | null
        }
        Insert: {
          created_at?: string
          date?: string | null
          exam_board?: string | null
          id?: string
          mark_scheme_processed_at?: string | null
          paper_code?: Database["public"]["Enums"]["paper_code"] | null
          paper_number?: string | null
          pdf_url?: string | null
          reading_insert_content?: string | null
          reading_insert_page_numbers?: number[] | null
          reading_insert_page_numbers_2?: number[] | null
          status?: Database["public"]["Enums"]["content_status"]
          subject?: Database["public"]["Enums"]["subject"] | null
          time_allowed?: number | null
          title?: string | null
        }
        Update: {
          created_at?: string
          date?: string | null
          exam_board?: string | null
          id?: string
          mark_scheme_processed_at?: string | null
          paper_code?: Database["public"]["Enums"]["paper_code"] | null
          paper_number?: string | null
          pdf_url?: string | null
          reading_insert_content?: string | null
          reading_insert_page_numbers?: number[] | null
          reading_insert_page_numbers_2?: number[] | null
          status?: Database["public"]["Enums"]["content_status"]
          subject?: Database["public"]["Enums"]["subject"] | null
          time_allowed?: number | null
          title?: string | null
        }
        Relationships: []
      }
      practice_answers: {
        Row: {
          ai_feedback: string | null
          ai_improvements: string[] | null
          ai_score: number | null
          ai_strengths: string[] | null
          answer_text: string | null
          auth_id: string
          created_at: string
          graded_at: string | null
          id: string
          practice_attempt_id: string
          question_id: string
          question_order: number
          updated_at: string
        }
        Insert: {
          ai_feedback?: string | null
          ai_improvements?: string[] | null
          ai_score?: number | null
          ai_strengths?: string[] | null
          answer_text?: string | null
          auth_id: string
          created_at?: string
          graded_at?: string | null
          id?: string
          practice_attempt_id: string
          question_id: string
          question_order: number
          updated_at?: string
        }
        Update: {
          ai_feedback?: string | null
          ai_improvements?: string[] | null
          ai_score?: number | null
          ai_strengths?: string[] | null
          answer_text?: string | null
          auth_id?: string
          created_at?: string
          graded_at?: string | null
          id?: string
          practice_attempt_id?: string
          question_id?: string
          question_order?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "practice_answers_practice_attempt_id_fkey"
            columns: ["practice_attempt_id"]
            isOneToOne: false
            referencedRelation: "practice_attempts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "practice_answers_question_id_fkey"
            columns: ["question_id"]
            isOneToOne: false
            referencedRelation: "questions"
            referencedColumns: ["id"]
          },
        ]
      }
      practice_attempts: {
        Row: {
          auth_id: string
          created_at: string
          graded_at: string | null
          id: string
          question_category: string
          set_size: number
          status: string
          type: string
        }
        Insert: {
          auth_id: string
          created_at?: string
          graded_at?: string | null
          id?: string
          question_category: string
          set_size: number
          status?: string
          type: string
        }
        Update: {
          auth_id?: string
          created_at?: string
          graded_at?: string | null
          id?: string
          question_category?: string
          set_size?: number
          status?: string
          type?: string
        }
        Relationships: []
      }
      products: {
        Row: {
          currency: string
          description: string | null
          id: string
          interval: string | null
          interval_count: number | null
          name: string
          price: number
          price_id: string
          type: string
        }
        Insert: {
          currency?: string
          description?: string | null
          id?: string
          interval?: string | null
          interval_count?: number | null
          name: string
          price: number
          price_id: string
          type: string
        }
        Update: {
          currency?: string
          description?: string | null
          id?: string
          interval?: string | null
          interval_count?: number | null
          name?: string
          price?: number
          price_id?: string
          type?: string
        }
        Relationships: []
      }
      question_categories: {
        Row: {
          category: string
          category_code: Database["public"]["Enums"]["category_code"]
          content: string | null
          created_at: string | null
          description: string | null
          id: string
          name: string
          paper_number: string
          subject: Database["public"]["Enums"]["subject"]
          tips: Json | null
          updated_at: string | null
        }
        Insert: {
          category: string
          category_code: Database["public"]["Enums"]["category_code"]
          content?: string | null
          created_at?: string | null
          description?: string | null
          id?: string
          name: string
          paper_number: string
          subject: Database["public"]["Enums"]["subject"]
          tips?: Json | null
          updated_at?: string | null
        }
        Update: {
          category?: string
          category_code?: Database["public"]["Enums"]["category_code"]
          content?: string | null
          created_at?: string | null
          description?: string | null
          id?: string
          name?: string
          paper_number?: string
          subject?: Database["public"]["Enums"]["subject"]
          tips?: Json | null
          updated_at?: string | null
        }
        Relationships: []
      }
      questions: {
        Row: {
          category: Database["public"]["Enums"]["question_types"] | null
          category_code: Database["public"]["Enums"]["category_code"] | null
          content: string | null
          created_at: string
          has_image: boolean | null
          hint_content: string | null
          id: string
          image_page_numbers: number[] | null
          is_practice_only: boolean | null
          mark_scheme_content: Json | null
          marks: number | null
          model_answer: string | null
          past_paper_id: string | null
          pdf_url: string | null
          question_order: number | null
          reading_insert_content: string | null
          reading_insert_content_2: string | null
          reading_insert_page_numbers: number[] | null
          status: Database["public"]["Enums"]["content_status"]
        }
        Insert: {
          category?: Database["public"]["Enums"]["question_types"] | null
          category_code?: Database["public"]["Enums"]["category_code"] | null
          content?: string | null
          created_at?: string
          has_image?: boolean | null
          hint_content?: string | null
          id?: string
          image_page_numbers?: number[] | null
          is_practice_only?: boolean | null
          mark_scheme_content?: Json | null
          marks?: number | null
          model_answer?: string | null
          past_paper_id?: string | null
          pdf_url?: string | null
          question_order?: number | null
          reading_insert_content?: string | null
          reading_insert_content_2?: string | null
          reading_insert_page_numbers?: number[] | null
          status?: Database["public"]["Enums"]["content_status"]
        }
        Update: {
          category?: Database["public"]["Enums"]["question_types"] | null
          category_code?: Database["public"]["Enums"]["category_code"] | null
          content?: string | null
          created_at?: string
          has_image?: boolean | null
          hint_content?: string | null
          id?: string
          image_page_numbers?: number[] | null
          is_practice_only?: boolean | null
          mark_scheme_content?: Json | null
          marks?: number | null
          model_answer?: string | null
          past_paper_id?: string | null
          pdf_url?: string | null
          question_order?: number | null
          reading_insert_content?: string | null
          reading_insert_content_2?: string | null
          reading_insert_page_numbers?: number[] | null
          status?: Database["public"]["Enums"]["content_status"]
        }
        Relationships: [
          {
            foreignKeyName: "questions_past_paper_id_fkey"
            columns: ["past_paper_id"]
            isOneToOne: false
            referencedRelation: "past_papers"
            referencedColumns: ["id"]
          },
        ]
      }
      subscriptions: {
        Row: {
          auth_id: string
          cancel_at_period_end: boolean
          created_at: string
          current_period_end: string
          id: string
          price_id: string
          subscription_id: string
        }
        Insert: {
          auth_id: string
          cancel_at_period_end?: boolean
          created_at?: string
          current_period_end: string
          id?: string
          price_id: string
          subscription_id: string
        }
        Update: {
          auth_id?: string
          cancel_at_period_end?: boolean
          created_at?: string
          current_period_end?: string
          id?: string
          price_id?: string
          subscription_id?: string
        }
        Relationships: []
      }
      users: {
        Row: {
          aspirational_grade: string | null
          auth_id: string
          created_at: string
          customer_id: string
          exam_board: string | null
          id: string
          onboarding_completed: boolean
          paper_attempts_count: number
          paper_attempts_reset_date: string | null
          practice_questions_attempted_count: number
          practice_questions_attempted_reset_date: string | null
          predicted_grade: string | null
          role: Database["public"]["Enums"]["user_role"]
          subjects: Json | null
          tutorial_seen: boolean
        }
        Insert: {
          aspirational_grade?: string | null
          auth_id: string
          created_at?: string
          customer_id: string
          exam_board?: string | null
          id?: string
          onboarding_completed?: boolean
          paper_attempts_count?: number
          paper_attempts_reset_date?: string | null
          practice_questions_attempted_count?: number
          practice_questions_attempted_reset_date?: string | null
          predicted_grade?: string | null
          role?: Database["public"]["Enums"]["user_role"]
          subjects?: Json | null
          tutorial_seen?: boolean
        }
        Update: {
          aspirational_grade?: string | null
          auth_id?: string
          created_at?: string
          customer_id?: string
          exam_board?: string | null
          id?: string
          onboarding_completed?: boolean
          paper_attempts_count?: number
          paper_attempts_reset_date?: string | null
          practice_questions_attempted_count?: number
          practice_questions_attempted_reset_date?: string | null
          predicted_grade?: string | null
          role?: Database["public"]["Enums"]["user_role"]
          subjects?: Json | null
          tutorial_seen?: boolean
        }
        Relationships: []
      }
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      is_admin: {
        Args: { user_id: string }
        Returns: boolean
      }
    }
    Enums: {
      attempt_status: "in_progress" | "submitted" | "grading" | "graded"
      category_code:
        | "LANG-P1-Q1"
        | "LANG-P1-Q2"
        | "LANG-P1-Q3"
        | "LANG-P1-Q4"
        | "LANG-P1-Q5"
        | "LANG-P2-Q1"
        | "LANG-P2-Q2"
        | "LANG-P2-Q3"
        | "LANG-P2-Q4"
        | "LANG-P2-Q5"
        | "LANG-P2-Q6"
        | "LANG-P2-Q7A"
        | "LANG-P2-Q7B"
        | "LANG-P2-B"
        | "LIT-P1-Q1A"
        | "LIT-P1-Q1B"
        | "LIT-P1-Q2"
        | "LIT-P2-Q1A"
        | "LIT-P2-Q1B"
        | "LIT-P2-Q2"
        | "LIT-P2-Q3"
      content_status: "draft" | "published" | "archived"
      paper_code: "1EN0/01" | "1EN0/02" | "1ET0/01" | "1ET0/02"
      question_types:
        | "Q1"
        | "Q1A"
        | "Q1B"
        | "Q2"
        | "Q3"
        | "Q4"
        | "Q5"
        | "Q6"
        | "Q7A"
        | "Q7B"
        | "Q8"
        | "Q9"
        | "SectionA_A"
        | "SectionA_B"
        | "SectionB"
        | "SectionB_Q2"
        | "SectionB_Q3"
      subject: "English Language" | "English Literature"
      user_role: "student" | "admin" | "super_admin"
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
}

type DatabaseWithoutInternals = Omit<Database, "__InternalSupabase">

type DefaultSchema = DatabaseWithoutInternals[Extract<keyof Database, "public">]

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])[TableName] extends {
      Row: infer R
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema["Tables"] &
        DefaultSchema["Views"])
    ? (DefaultSchema["Tables"] &
        DefaultSchema["Views"])[DefaultSchemaTableNameOrOptions] extends {
        Row: infer R
      }
      ? R
      : never
    : never

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Insert: infer I
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Insert: infer I
      }
      ? I
      : never
    : never

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Update: infer U
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Update: infer U
      }
      ? U
      : never
    : never

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
    | keyof DefaultSchema["Enums"]
    | { schema: keyof DatabaseWithoutInternals },
  EnumName extends DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"]
    : never = never,
> = DefaultSchemaEnumNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema["Enums"]
    ? DefaultSchema["Enums"][DefaultSchemaEnumNameOrOptions]
    : never

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    | keyof DefaultSchema["CompositeTypes"]
    | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"]
    : never = never,
> = PublicCompositeTypeNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema["CompositeTypes"]
    ? DefaultSchema["CompositeTypes"][PublicCompositeTypeNameOrOptions]
    : never

export const Constants = {
  graphql_public: {
    Enums: {},
  },
  public: {
    Enums: {
      attempt_status: ["in_progress", "submitted", "grading", "graded"],
      category_code: [
        "LANG-P1-Q1",
        "LANG-P1-Q2",
        "LANG-P1-Q3",
        "LANG-P1-Q4",
        "LANG-P1-Q5",
        "LANG-P2-Q1",
        "LANG-P2-Q2",
        "LANG-P2-Q3",
        "LANG-P2-Q4",
        "LANG-P2-Q5",
        "LANG-P2-Q6",
        "LANG-P2-Q7A",
        "LANG-P2-Q7B",
        "LANG-P2-B",
        "LIT-P1-Q1A",
        "LIT-P1-Q1B",
        "LIT-P1-Q2",
        "LIT-P2-Q1A",
        "LIT-P2-Q1B",
        "LIT-P2-Q2",
        "LIT-P2-Q3",
      ],
      content_status: ["draft", "published", "archived"],
      paper_code: ["1EN0/01", "1EN0/02", "1ET0/01", "1ET0/02"],
      question_types: [
        "Q1",
        "Q1A",
        "Q1B",
        "Q2",
        "Q3",
        "Q4",
        "Q5",
        "Q6",
        "Q7A",
        "Q7B",
        "Q8",
        "Q9",
        "SectionA_A",
        "SectionA_B",
        "SectionB",
        "SectionB_Q2",
        "SectionB_Q3",
      ],
      subject: ["English Language", "English Literature"],
      user_role: ["student", "admin", "super_admin"],
    },
  },
} as const

